<!--@format-->
<template>
    <div class="create-social-post-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>{{ options.title }}</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div v-if="isLoading" class="loading-view">
                    <loading-screen-svg />
                </div>
                <div v-if="currentStep === 'summary-post-review' && !isLoading">
                    <social-media-create-post-review
                        :post="getPostReviewDetails"
                        :post-status="postStatus"
                        @go-to-step="goToStep($event)"
                        @close-widget="closeWidget()"
                        @unschedule="unschedulePost()"
                    />
                </div>

                <div
                    v-if="currentStep == 'starting-point' && !isLoading"
                    class="create-social-post-step starting-point"
                >
                    <div v-if="isCreatePost && !hasEnabledAccounts">
                        <social-media-manage-board-no-records-card
                            no-records-title="Connect an Account"
                            no-records-content="You haven't connected any account yet. Click below to connect an account so you can start publishing your social media posts."
                            @click="handleConnectAccount"
                        />
                    </div>
                    <div v-else>
                        <social-media-strategy-step
                            v-model="postCreationSteps['starting-point'].next"
                            :start-options="startOptionsForSocialMedia"
                        />
                    </div>
                </div>
                <div
                    v-if="
                        (currentStep == 'post-fields' ||
                            currentStep == 'edit-post-info' ||
                            currentStep === 'add-social-platform' ||
                            currentStep === 'previously-sent-post-edit' ||
                            currentStep === 'existing-template-edit') &&
                        !isLoading
                    "
                >
                    <div class="create-social-post-step">
                        <div
                            v-if="postCreationSteps[currentStep].only !== 'add-platform'"
                            class="post-name-container field-container"
                        >
                            <app-input
                                v-model="post.name"
                                placeholder="Name"
                                label="Name"
                                :is-valid="isFormInputsValid.name"
                                :error="errorMessage"
                                @blur="$v.post.name.$touch()"
                            />
                        </div>

                        <div
                            v-if="
                                postCreationSteps[currentStep].only === 'add-platform' ||
                                postCreationSteps[currentStep].only === ''
                            "
                            class="field-container"
                        >
                            <social-media-accounts-dropdown
                                :client-id="clientId"
                                :selected="accountsSelected"
                                :step="currentStep"
                                :is-valid="isFormInputsValid.accounts"
                                :error="errorMessage"
                                @input="addList($event)"
                                @remove="removeList"
                                @close="$v.post.accounts.$touch()"
                            />
                        </div>
                        <div
                            v-if="
                                postCreationSteps[currentStep].only !== 'add-platform' ||
                                postCreationSteps[currentStep].only === ''
                            "
                            class="categories field-container"
                        >
                            <global-category-dropdown
                                :account-id="accountId"
                                :selected="categoriesSelected"
                                show-selected-up
                                @input="addListCategories($event)"
                                @remove="deleteCategory"
                            />
                        </div>
                    </div>
                </div>
                <div
                    v-if="currentStep == 'schedule-or-publish' && !isLoading"
                    class="create-social-post-step schedule-point"
                >
                    <label class="title">When should the post be sent?</label>
                    <div class="is-scheduled">
                        <label
                            class="now"
                            :class="{
                                selected:
                                    postCreationSteps['schedule-or-publish'].next ===
                                    'publish-post-now',
                            }"
                        >
                            <input
                                v-model="postCreationSteps['schedule-or-publish'].next"
                                class="radio-schedule"
                                name="rad-schedule"
                                type="radio"
                                value="publish-post-now"
                            />
                            Now
                        </label>
                        <label
                            class="now"
                            :class="{
                                selected:
                                    postCreationSteps['schedule-or-publish'].next ===
                                    'schedule-post',
                            }"
                        >
                            <input
                                v-model="postCreationSteps['schedule-or-publish'].next"
                                class="radio-schedule"
                                name="rad-schedule"
                                type="radio"
                                value="schedule-post"
                            />
                            Schedule
                        </label>
                    </div>
                    <div
                        v-if="postCreationSteps['schedule-or-publish'].next == 'schedule-post'"
                        class="schedule-post-fieldset"
                    >
                        <div class="date">
                            <app-date-picker
                                v-model="schedule.date"
                                format="MMM dd, yyyy"
                                :disabled-dates="disabledDates"
                                placeholder="Send Date"
                            />
                        </div>
                        <time-picker v-model="schedule.time" />
                        <timezone-picker v-model="schedule.timezone" />
                    </div>
                </div>
                <div
                    v-if="
                        (currentStep == 'send-to-create-post-view' ||
                            currentStep == 'template' ||
                            currentStep == 'schedule-post' ||
                            currentStep == 'publish-post-now' ||
                            currentStep == 'previous') &&
                        !isLoading
                    "
                    class="create-social-post-step"
                >
                    <loading-screen-svg />
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn" @click="closeWidget"> Cancel </app-button>
                </div>
                <div v-if="!getPostReviewDetails.isScheduled" class="action-container">
                    <app-button
                        v-if="
                            currentStep === 'schedule-or-publish' ||
                            currentStep === 'edit-post-info'
                        "
                        class="back-btn"
                        @click="goBack()"
                    >
                        Back
                    </app-button>
                    <app-button
                        v-if="
                            (currentStep === 'starting-point' && hasEnabledAccounts) ||
                            currentStep === 'post-fields' ||
                            currentStep === 'summary-post-review' ||
                            currentStep === 'previously-sent-post-edit' ||
                            currentStep === 'existing-template-edit'
                        "
                        class="save-btn"
                        @click="nextStep()"
                    >
                        {{ currentStep === 'summary-post-review' ? 'Save & Schedule' : 'Next' }}
                    </app-button>
                    <app-button
                        v-if="
                            currentStep === 'schedule-or-publish' ||
                            currentStep === 'edit-post-info' ||
                            currentStep === 'add-social-platform'
                        "
                        class="save-btn"
                        @click="saveEdit()"
                    >
                        {{ editModeText }}
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { SocialMediaPostsMixin } from '@/mixins/social-media-posts-mixin';
import { SocialMediaPostTemplatesMixin } from '@/mixins/social-media-post-templates-mixin';
import { required } from 'vuelidate/lib/validators';
import EventBus from '@/scripts/event-bus.js';
import { LogLevel } from '@/scripts/logger';

const AppButton = () => import('@/components/common/app-button');
const AppInput = () => import('@/components/common/app-input');
const AppDatePicker = () => import('@/components/common/app-date-picker');
const TimePicker = () => import('@/components/common/time-picker');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');
const TimezonePicker = () => import('@/components/common/timezone-picker');
const SocialMediaAccountsDropdown = () =>
    import('@/components/social-media/social-media-accounts-dropdown');
const GlobalCategoryDropdown = () => import('@/components/common/global-category-dropdown');
const SocialMediaCreatePostReview = () =>
    import('@/components/social-media/social-media-create-post-review');
const SocialMediaStrategyStep = () =>
    import('@/components/sliding-widgets/social-media/social-media-strategy-step');
const SocialMediaManageBoardNoRecordsCard = () =>
    import(
        '@/components/social-media/social-media-board/social-media-manage-board-no-records-card'
    );

export default {
    name: 'create-social-post-widget',

    components: {
        'app-button': AppButton,
        'app-input': AppInput,
        'app-date-picker': AppDatePicker,
        'time-picker': TimePicker,
        'widget-close-svg': WidgetCloseSvg,
        'loading-screen-svg': LoadingScreenSvg,
        'timezone-picker': TimezonePicker,
        'social-media-accounts-dropdown': SocialMediaAccountsDropdown,
        'global-category-dropdown': GlobalCategoryDropdown,
        'social-media-create-post-review': SocialMediaCreatePostReview,
        'social-media-strategy-step': SocialMediaStrategyStep,
        'social-media-manage-board-no-records-card': SocialMediaManageBoardNoRecordsCard,
    },

    mixins: [SocialMediaPostsMixin, SocialMediaPostTemplatesMixin],

    props: {
        widget: {
            type: Object,
            required: true,
        },

        options: {
            type: Object,
            default() {
                return {
                    title: 'Create Social Post ',
                };
            },
        },
    },

    data() {
        return {
            isLoading: false,
            currentStep: 'starting-point',
            actualStatus: '',
            schedule: {
                time: null,
                timezone: this.$helpers.guessTimezone(),
                date: null,
            },

            post: {
                id: 1,
                name: null,
                accounts: [],
                categories: [],
            },

            originalPost: {},
            postReviewDetails: {},
            startOptionsForSocialMedia: [
                {
                    value: 'previously-sent-post-edit',
                    name: 'Previously Sent Post',
                    imageUrl: require('@/assets/images/social-posts/create-from-previous.png'),
                },
                {
                    value: 'existing-template-edit',
                    name: 'Existing Template',
                    imageUrl: require('@/assets/images/social-posts/create-from-previous.png'),
                },
                {
                    value: 'post-fields',
                    name: 'Start Fresh',
                    imageUrl: require('@/assets/images/social-posts/create-new.png'),
                },
            ],

            postCreationSteps: {
                'starting-point': {
                    next: 'post-fields',
                    previous: '',
                    only: '',
                },

                'post-fields': {
                    next: 'send-to-create-post-view',
                    previous: 'starting-point',
                    only: '',
                },

                'summary-post-review': {
                    next: 'schedule-or-publish',
                    previous: '',
                    only: '',
                },

                'edit-post-info': {
                    next: 'edited-post-info',
                    previous: 'summary-post-review',
                    only: '',
                },

                'previously-sent-post-edit': {
                    next: 'send-to-create-from-previous-post',
                    previous: 'starting-point',
                    only: '',
                },

                'existing-template-edit': {
                    next: 'send-to-create-from-existing-template',
                    previous: 'starting-point',
                    only: '',
                },

                'add-social-platform': {
                    next: 'save-platforms',
                    previous: '',
                    only: 'add-platform',
                },

                'schedule-or-publish': {
                    next: 'schedule-post',
                    previous: 'summary-post-review',
                    only: '',
                },
            },

            errorMessage: 'This field is required',
        };
    },

    validations() {
        return {
            post: {
                name: {
                    required,
                },

                accounts: {
                    required,
                },

                categories: {
                    required: false,
                },
            },
        };
    },

    computed: {
        clientId() {
            return this.widget.options.clientId;
        },

        accountId() {
            return this.widget.options.accountId;
        },

        isCreatePost() {
            return this.widget.options.isCreatePost;
        },

        templateElement() {
            return this.widget.options.template;
        },

        postStatus() {
            return this.widget.options.status;
        },

        hasAccounts() {
            return this.widget.options.accounts && this.widget.options.accounts.length > 0;
        },

        hasEnabledAccounts() {
            return (
                this.hasAccounts &&
                this.widget.options.accounts.some(
                    (account) => account.socialMediaStatus === 'enabled',
                )
            );
        },

        getPostDate() {
            let result = '';
            result += this.schedule.date;
            result += 'T';
            result += this.prependCero(this.schedule.hour, 2);
            result += ':';
            result += this.prependCero(this.schedule.minute, 2);
            result += ':00';
            return result;
        },

        disabledDates() {
            const currentDate = new Date();

            return { to: new Date(currentDate.setDate(currentDate.getDate() - 1)) };
        },

        getCategories() {
            let categories = '';
            if (this.post.categories.length == 0) {
                return '';
            }
            for (let i = 0; i < this.post.categories.length; i++) {
                categories += this.post.categories[i];
                if (i < this.post.categories.length - 1) {
                    categories += ',';
                }
            }
            return categories;
        },

        accountsSelected() {
            return this.post.accounts;
        },

        categoriesSelected() {
            return this.post.categories;
        },

        isEditMode() {
            return this.widget.postId !== null && this.widget.postId !== undefined;
        },

        isBuilderView() {
            return this.widget.isBuilderView !== null && this.widget.isBuilderView !== undefined
                ? this.widget.isBuilderView
                : false;
        },

        getPostReviewDetails() {
            return this.postReviewDetails;
        },

        editModeText() {
            if (this.actualStatus !== '' && this.actualStatus === 'draft') {
                if (this.currentStep === 'schedule-or-publish') {
                    if (this.postCreationSteps['schedule-or-publish'].next === 'publish-post-now') {
                        return 'Publish Now';
                    }

                    return 'Schedule';
                } else {
                    return 'Save';
                }
            }
            return 'Save';
        },

        isPostFormStep() {
            return (
                this.currentStep === 'post-fields' ||
                this.currentStep === 'edit-post-info' ||
                this.currentStep === 'existing-template-edit' ||
                this.currentStep === 'previously-sent-post-edit'
            );
        },

        isFormInputsValid() {
            return {
                name: !(this.$v.post.name.$dirty && this.$v.post.name.$invalid),
                accounts: !(this.$v.post.accounts.$dirty && this.$v.post.accounts.$invalid),
                categories: !(this.$v.post.categories.$dirty && this.$v.post.categories.$invalid),
            };
        },

        isFormValid() {
            return !this.isPostFormStep || !this.$v.post.$invalid;
        },

        sendDate() {
            if (this.postCreationSteps[this.currentStep].next === 'schedule-post') {
                var year = this.schedule.date.getFullYear();
                var month = ('0' + (this.schedule.date.getMonth() + 1)).slice(-2);
                var day = ('0' + this.schedule.date.getDate()).slice(-2);
                return this.$moment.tz(
                    `${year}-${month}-${day} ${this.formattedTime}`,
                    this.schedule.timezone.name,
                );
            } else {
                return null;
            }
        },

        formattedTime() {
            return this.$moment.utc(this.schedule.time, 'hh:mma').format('HH:mm');
        },

        baseUrl() {
            return this.$store.getters.baseUrl;
        },
    },

    mounted() {
        if (typeof this.widget.step == 'string') {
            this.currentStep = this.widget.step;
        }

        if (typeof this.widget.actualData != 'undefined') {
            this.post.name = this.widget.actualData.name;
            this.post.accounts = this.widget.actualData.accounts;
            this.post.categories = this.widget.actualData.categories.split(',');
        }
    },

    created() {
        if (this.isEditMode) {
            if (this.widget.step != 'undefined' && this.widget.step === 'add-social-platform') {
                if (this.widget.accountsSelected != 'undefined') {
                    this.post.accounts = this.widget.accountsSelected.accounts;
                }
            } else {
                this.getPostToEdit();
            }
        } else if (this.templateElement) {
            this.getPostTemplate(this.templateElement);
        }

        EventBus.$on('social-post-select', this.getPreviouslyPost);
        EventBus.$on('post-template-select', this.getPostTemplate);
    },

    beforeDestroy() {
        EventBus.$off('social-post-select', this.getPreviouslyPost);
        EventBus.$off('post-template-select', this.getPostTemplate);
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        refreshEventPostsMainPage() {
            EventBus.$emit('social-posts:update');
        },

        prependCero(num, size) {
            var s = num + '';
            while (s.length < size) {
                s = '0' + s;
            }
            return s;
        },

        goToStep(step) {
            this.currentStep = step;
        },

        unschedulePost() {
            this.isLoading = true;
            const { postId } = this.widget;

            this.unscheduleAPost(postId, this.clientId)
                .then(() => {
                    EventBus.$emit('social-posts:update');
                    this.$helpers.showSuccessNotification('Your post has been unscheduled.');
                    this.getPostToEdit();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('Failed to unschedule your post.', {
                        error,
                    });
                })
                .finally(() => {
                    this.refreshEventPostsMainPage();
                    this.isLoading = false;
                });
        },

        addList(item) {
            const exist = this.post.accounts.some((element) => element.id === item.id);

            if (!exist) {
                this.post.accounts.push(item);
            }
        },

        addListCategories(item) {
            const exist = this.post.categories.some((element) => element === item.name);

            if (!exist) {
                this.post.categories.push(item.name);
            }
        },

        removeList(item) {
            this.post.accounts.splice(this.post.accounts.indexOf(item), 1);
        },

        deleteCategory(item) {
            this.post.categories.splice(this.post.categories.indexOf(item), 1);
        },

        validateFields() {
            this.$v.post.name.$touch();
            this.$v.post.accounts.$touch();
            this.$v.post.categories.$touch();
        },

        nextStep() {
            if (!this.isFormValid) {
                this.validateFields();
                return;
            }

            this.currentStep = this.postCreationSteps[this.currentStep].next;

            if (this.currentStep === 'existing-template-edit') {
                this.openChoosePostTemplateWidget();
            }

            if (this.currentStep === 'previously-sent-post-edit') {
                this.openChoosePreviousPostWidget();
            }

            if (this.currentStep === 'send-to-create-from-previous-post') {
                this.sendToCreateAPostFromPreviousPost();
            }

            if (this.currentStep === 'send-to-create-from-existing-template') {
                this.sendToCreateAPostFromExistingTemplate();
            }

            if (this.currentStep === 'send-to-create-post-view') {
                this.sendToCreatePostView();
            }

            if (this.currentStep === 'schedule-post') {
                this.schedulePost();
            }

            if (this.currentStep === 'publish-post-now') {
                this.publishNow();
            }
        },

        schedulePost() {
            const params = {
                postName: this.post.name,
                date: this.getPostDate,
                categories: this.post.categories,
                publishTo: this.post.accounts.split(','),
            };

            EventBus.$emit('schedule-social-post', params);
            this.closeWidget();
        },

        publishNow() {
            const params = {
                date: 'now',
            };

            EventBus.$emit('schedule-social-post', params);
        },

        sendToCreatePostView() {
            const dest =
                `${this.baseUrl}/SocialMedias/SocialPosts/Create?` +
                this.serialize({
                    name: this.post.name,
                    categories: this.getCategories,
                    accounts: this.post.accounts.map((item) => item.id).toString(),
                });
            this.$router.push(dest).then(() => {
                this.closeWidget();
            });
        },

        sendToCreateAPostFromPreviousPost() {
            const dest =
                `${this.baseUrl}/SocialMedias/SocialPosts/Create?` +
                this.serialize({
                    name: this.post.name,
                    categories: this.getCategories,
                    accounts: this.post.accounts.map((item) => item.id).toString(),
                    previouspost: this.post.id,
                    postTemplate: this.post.socialPostTemplateId,
                });

            this.$router.push(dest).then(() => {
                this.closeWidget();
            });
        },

        sendToCreateAPostFromExistingTemplate() {
            const dest =
                `${this.baseUrl}/SocialMedias/SocialPosts/Create?` +
                this.serialize({
                    name: this.post.name,
                    categories: this.getCategories,
                    accounts: this.post.accounts.map((item) => item.id).toString(),
                    postTemplate: this.post.id ? this.post.sourceTemplateId : this.post.id,
                });

            this.$router.push(dest).then(() => {
                this.closeWidget();
            });
        },

        redirectEdited() {
            const dest =
                `${this.baseUrl}/SocialMedias/SocialPosts/Create?` +
                this.serialize({
                    name: this.widget.actualData.name,
                    categories: this.widget.actualData.categories,
                    accounts: this.widget.actualData.accounts.map((item) => item.id).toString(),
                });
            this.$router
                .push(dest)
                .then(() => {
                    this.closeWidget();
                })
                .catch((error) => {
                    if (error.name === 'NavigationDuplicated') {
                        EventBus.$emit('duplicate-uri');
                        this.closeWidget();
                    }
                });
        },

        addPlatformToEditView() {
            EventBus.$emit('add-social-platform', this.accountsSelected);
            this.closeWidget();
        },

        sendPostDataToBuilderView() {
            EventBus.$emit('update-social-post-info', this.post);
            this.closeWidget();
        },

        async getPostToEdit() {
            this.isLoading = true;

            const { postId } = this.widget;

            this.getPostDetails(postId, this.clientId)
                .then((response) => {
                    let arrayAccounts = response.AccountPosts.map((item) => {
                        return {
                            id: item.SocialNetworkAccount.Id,
                            name: item.SocialNetworkAccount.AccountName,
                            type: item.SocialNetworkAccount.SocialNetwork,
                        };
                    });
                    this.post = {
                        id: response.Id,
                        name: response.PostName,
                        accounts: arrayAccounts,
                        categories: response.Categories,
                    };
                    this.originalPost = {
                        id: response.Id,
                        name: response.PostName,
                        accounts: JSON.parse(JSON.stringify(arrayAccounts)),
                        categories: JSON.parse(JSON.stringify(response.Categories)),
                    };

                    this.postReviewDetails = {
                        id: response.Id,
                        accounts: JSON.parse(JSON.stringify(arrayAccounts)),
                        categories: JSON.parse(JSON.stringify(response.Categories)),
                        postText: response.PostText,
                        postMediaData: response.PostMediaData,
                        pageShareUrl: response.PageShareUrl,
                        isScheduled: response.Status === 'scheduled',
                    };

                    if (response.SchedulingDate !== null) {
                        if (response.Timezone) {
                            this.postReviewDetails.sendDate = this.$moment(
                                response.SchedulingDate,
                            ).tz(response.Timezone);
                        } else {
                            this.postReviewDetails.sendDate = this.$moment(response.SchedulingDate);
                        }
                    }

                    if (response.Timezone && response.Timezone !== null) {
                        this.schedule.timezone = this.$helpers.getTimezoneByName(response.Timezone);
                    } else {
                        this.schedule.timezone = this.$helpers.guessTimezone();
                    }

                    if (!this.postReviewDetails.sendDate) {
                        this.schedule.date = new Date();
                        this.schedule.time = this.$moment().format('HH:mm');
                    } else {
                        this.schedule.date = new Date(
                            this.postReviewDetails.sendDate.format('MM/DD/YYYY'),
                        );
                        this.schedule.time = this.postReviewDetails.sendDate.format('HH:mm');
                    }

                    this.actualStatus = response.Status;
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('Failed to get social post.', { error });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getPreviouslyPost(item) {
            this.isLoading = true;
            this.getPostDetails(item.id, this.clientId)
                .then((response) => {
                    let arrayAccounts = response.AccountPosts.map((account) => {
                        return {
                            id: account.SocialNetworkAccount.Id,
                            name: account.SocialNetworkAccount.AccountName,
                            type: account.SocialNetworkAccount.SocialNetwork,
                        };
                    });

                    this.post = {
                        id: response.Id,
                        name: response.PostName,
                        accounts: arrayAccounts,
                        categories: response.Categories,
                        socialPostTemplateId: response.SocialPostTemplateId,
                    };

                    this.currentStep = 'previously-sent-post-edit';
                })
                .catch((error) => {
                    this.currentStep = 'starting-point';
                    this.$helpers.showFailNotification('Failed to get social post.', { error });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getPostTemplate(item) {
            this.isLoading = true;
            this.getPostTemplateDetails(item.id, this.accountId)
                .then((response) => {
                    this.post = {
                        id: response.Id,
                        name: response.TemplateName,
                        accounts: [],
                        categories: response.Categories,
                        sourceTemplateId: response.SourceTemplateId || response.Id,
                    };

                    this.currentStep = 'existing-template-edit';
                })
                .catch((error) => {
                    if (this.templateElement) {
                        this.closeWidget();
                    } else {
                        this.currentStep = 'starting-point';
                    }
                    this.$helpers.showFailNotification('Failed to get social post template.', {
                        error,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        saveEdit() {
            if (!this.isFormValid) {
                this.validateFields();
                return;
            }

            if (this.postCreationSteps[this.currentStep].next === 'publish-post-now') {
                this.publishPostNow();
            } else if (this.postCreationSteps[this.currentStep].next === 'schedule-post') {
                this.saveDateToPublish();
            } else if (this.postCreationSteps[this.currentStep].next === 'save-platforms') {
                if (this.isEditMode) {
                    this.addPlatformToEditView();
                } else {
                    this.redirectEdited();
                }
            } else {
                if (this.isBuilderView) {
                    this.sendPostDataToBuilderView();
                } else {
                    this.saveDraftInfo();
                }
            }
        },

        publishPostNow() {
            this.isLoading = true;
            const { postId } = this.widget;

            this.publishPost(postId, this.clientId)
                .then(() => {
                    this.$helpers.showSuccessNotification(
                        'The post is send to publish. It will show up momentarily.',
                    );
                    this.$router.push(`${this.baseUrl}/SocialMedias/SocialPosts`);
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('Failed to publish your post.', { error });
                })
                .finally(() => {
                    this.refreshEventPostsMainPage();
                    this.closeWidget();
                    this.isLoading = false;
                });
        },

        saveDateToPublish() {
            this.isLoading = true;
            const { postId } = this.widget;

            const postPayload = {
                schedulingDate: this.sendDate
                    ? this.sendDate.utc().format('YYYY-MM-DDTHH:mm:ss') + 'z'
                    : null,

                timezone: this.schedule.timezone.name,
            };

            this.scheduleAPost(postId, this.clientId, postPayload)
                .then(() => {
                    this.closeWidget();
                    this.$helpers.showSuccessNotification('Your post has been scheduled.');
                    this.$router.push(`${this.baseUrl}/SocialMedias/SocialPosts`);
                })
                .catch((error) => {
                    let errorMessage = '';
                    if (error.response.data.data) {
                        errorMessage = 'because of ' + error.response.data.data;
                    }
                    this.$helpers.showFailNotification(
                        'Failed to schedule your post' + errorMessage,
                        { error },
                    );
                })
                .finally(() => {
                    this.refreshEventPostsMainPage();
                    this.closeWidget();
                    this.isLoading = false;
                });
        },

        saveDraftInfo() {
            if (this.post.accounts.length === 0) {
                this.$helpers.showFailNotification(
                    'You need to have at least one account for the post.',
                    { level: LogLevel.INFO },
                );
            }

            this.isLoading = true;
            const { postId } = this.widget;

            const postPayload = {
                postName: this.post.name,
                postCategories: this.post.categories,
                socialNetworkAccountIds: this.post.accounts.map((element) => element.id.toString()),
            };

            this.updateWidgetPostDraft(postId, this.clientId, postPayload)
                .then(() => {
                    this.$helpers.showSuccessNotification('Your post has been updated.');
                    this.getPostToEdit();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('Failed to update your post.', { error });
                })
                .finally(() => {
                    this.refreshEventPostsMainPage();
                    this.closeWidget();
                    this.isLoading = false;
                });
        },

        goBack() {
            this.currentStep =
                this.postCreationSteps[this.currentStep].previous !== ''
                    ? this.postCreationSteps[this.currentStep].previous
                    : 'starting-point';
        },

        openChoosePreviousPostWidget() {
            const widget = {
                name: 'social-post-select-widget',
                options: {
                    clientId: this.clientId,
                },
            };

            this.currentStep = 'starting-point';
            EventBus.$emit('open-widget', widget);
        },

        openChoosePostTemplateWidget() {
            const widget = {
                name: 'social-post-select-widget',
                options: {
                    accountId: this.accountId,
                    clientId: this.clientId,
                    isTemplates: true,
                },
            };

            this.currentStep = 'starting-point';
            EventBus.$emit('open-widget', widget);
        },

        handleConnectAccount() {
            EventBus.$emit('close-widget', this.widget);
            this.$router.push(`${this.baseUrl}/SocialMedias`);
        },

        serialize(obj) {
            var queryString = Object.keys(obj)
                .map((key) => {
                    return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
                })
                .join('&');

            return queryString;
        },
    },
};
</script>

<style>
.create-social-post-widget .widget-contents-container .content-wrapper .loading-view {
    display: flex;
    justify-content: center;
    align-items: center;
}

.create-social-post-widget .widget-contents-container .loading-screen {
    margin-left: 0px;
}

.create-social-post-widget .widget-contents-container .widget-footer .action-container {
    display: flex;
}

.create-social-post-widget .widget-contents-container .widget-footer .action-container .back-btn {
    margin-right: 15px;
    background: transparent;
    color: #18aeff;
}

.create-social-post-widget .widget-contents-container .widget-footer .action-container .btn {
    margin-left: 15px;
}

.create-social-post-widget .widget-contents-container .widget-footer .action-container .back-btn {
    background: transparent;
    color: #18aeff;
}

.create-social-post-widget .field-container .lists {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -7px;
}

.create-social-post-widget .field-container .lists .list {
    font-size: 11px;
    padding: 0px 7px;
    border: 1px solid #cac6cb;
    border-radius: 15px;
    margin: 0 7px 9px 7px;
    display: flex;
    align-items: center;
}

.create-social-post-widget .field-container .lists .list .x {
    margin-left: 12px;
    width: 7px;
    cursor: pointer;
}

.create-social-post-widget .field-container .tag-list-input-results .tag-list-input-result-item .x {
    margin-left: 12px;
    width: 10px;
    cursor: pointer;
}

.create-social-post-widget .field-container .lists .list .q23-linkedin-svg,
.create-social-post-widget .field-container .lists .list .p23-facebook-svg,
.create-social-post-widget .field-container .lists .list .q24-x-logo-svg,
.create-social-post-widget .field-container .lists .list .u23-instagram-svg {
    width: 19px;
    margin-right: 6px;
}

.create-social-post-widget .field-container .lists .list .x path,
.create-social-post-widget
    .field-container
    .tag-list-input-results
    .tag-list-input-result-item
    .x
    .a {
    fill: #ee206f;
}

.create-social-post-widget .field-container .social-media-accounts-dropdown {
    margin-bottom: 10px;
}

.create-social-post-widget .is-scheduled {
    display: flex;
    justify-content: space-between;
    max-width: 250px;
    align-items: center;
    margin: 0 auto;
}

.create-social-post-widget .is-scheduled label {
    display: flex;
    align-items: center;
    justify-content: center;
    font: normal normal 400 16px/20px Roboto;
}

.create-social-post-widget .is-scheduled label .radio-schedule {
    appearance: none;
    border-radius: 50%;
    border: 5px solid #fff;
    outline: 2px solid #382153;
    height: 30px;
    width: 30px;
}

.create-social-post-widget .is-scheduled label input[type='radio'] {
    margin: 0px 10px 0px 0px;
}

.create-social-post-widget .is-scheduled label.selected .radio-schedule {
    background: #382153;
}

.create-social-post-widget .schedule-post-fieldset {
    padding: 15px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.create-social-post-widget .schedule-post-fieldset .date {
    width: 100%;
    margin-bottom: 10px;
}

.create-social-post-widget .schedule-post-fieldset .time-picker {
    margin-bottom: 10px;
}

.create-social-post-widget .schedule-post-fieldset .date .app-date-picker input {
    padding: 9px 15px !important;
}

.create-social-post-widget
    .schedule-post-fieldset
    .date
    .app-date-picker
    .icon-container
    .calendar-svg
    path,
.create-social-post-widget
    .schedule-post-fieldset
    .date
    .app-date-picker
    .icon-container
    .calendar-svg
    rect {
    fill: #f30070 !important;
}

.create-social-post-widget
    .schedule-post-fieldset
    .date
    .app-date-picker
    .input-container:hover
    .icon-container
    .calendar-svg
    path,
.create-social-post-widget
    .schedule-post-fieldset
    .date
    .app-date-picker
    .input-container:hover
    .icon-container
    .calendar-svg
    rect {
    fill: #f30070 !important;
}

.create-social-post-widget
    .schedule-post-fieldset
    .date
    .app-date-picker
    .input-container:focus-within
    .icon-container
    .calendar-svg
    path,
.create-social-post-widget
    .schedule-post-fieldset
    .date
    .app-date-picker
    .input-container:focus-within
    .icon-container
    .calendar-svg
    rect {
    fill: #18aeff !important;
}

.create-social-post-widget .schedule-post-fieldset .time-picker .app-input input {
    text-align: center;
    padding: 9px 15px !important;
}

.create-social-post-widget .schedule-post-fieldset .time-picker .colon {
    padding-bottom: 8px !important;
    margin: 0 5px;
}

.create-social-post-widget .schedule-post-fieldset .time-picker .meridian {
    margin-left: 10px;
}

.create-social-post-widget .schedule-post-fieldset .time-picker .multiselect__tags {
    min-height: 41px !important;
}

.create-social-post-widget .schedule-post-fieldset .time .time-input {
    margin: 0 5px;
}

.create-social-post-widget .schedule-post-fieldset .time-input {
    max-width: 120px;
}

.create-social-post-widget .schedule-post-fieldset select {
    background: #fafafa;
    font-size: 1em;
    border: 2px solid #cac6cb;
    padding: 7px 15px;
    border-radius: 20px;
    color: #382153;
    outline: none;
    margin: 5px 0;
    flex-grow: 1;
}

.create-social-post-widget .schedule-post-fieldset .timezone {
    width: 100%;
}

.create-social-post-widget .loading-screen {
    text-align: center;
}

.create-social-post-widget .create-social-post-step.starting-point .title {
    display: block;
    margin: 0 auto;
    text-align: center;
    background-color: white;
    transform: translate(0, -50%);
    width: calc(100% - 40px);
    min-width: 280px;
}

.create-social-post-widget .create-social-post-step.schedule-point {
    border: 2px solid #e9e9ef;
    padding: 40px 30px 30px 30px;
    border-radius: 20px;
    position: relative;
}

.create-social-post-widget .create-social-post-step.schedule-point .title {
    position: absolute;
    top: -12px;
    left: 25%;
    font: normal normal 500 18px/20px Roboto;
    color: #382153;
    background: #ffffff;
    display: block;
    padding: 0 30px;
    margin: 0;
}

.create-social-post-widget
    .create-social-post-step.starting-point
    .create-social-post-options-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
}

.create-social-post-widget
    .create-social-post-step.starting-point
    .create-social-post-options-list
    .social-post-option {
    width: 50%;
    padding: 15px;
}

.create-social-post-widget
    .create-social-post-step.starting-point
    .create-social-post-options-list
    .social-post-option.--active
    img {
    border: 2px solid #18aeff !important;
}

.create-social-post-widget
    .create-social-post-step.starting-point
    .create-social-post-options-list
    .social-post-option
    label {
    display: block;
    width: 100%;
    text-align: center;
    cursor: pointer;
}

.create-social-post-widget
    .create-social-post-step.starting-point
    .create-social-post-options-list
    .social-post-option
    label:hover
    img {
    border: 2px solid #333;
}

.create-social-post-widget
    .create-social-post-step.starting-point
    .create-social-post-options-list
    .social-post-option
    label
    img {
    border: 2px solid transparent;
    border-radius: 10px;
    overflow: hidden;
    width: 100%;
    height: auto;
    margin-bottom: 15px;
    transition: all 0.3s ease-in-out;
}

.create-social-post-widget
    .create-social-post-step.starting-point
    .create-social-post-options-list
    .social-post-option
    label
    input,
.create-social-post-widget
    .create-social-post-step.starting-point
    .create-social-post-options-list
    .social-post-option
    label
    p {
    display: inline-block;
}

.create-social-post-widget
    .create-social-post-step.starting-point
    .create-social-post-options-list
    .social-post-option
    label
    input {
    margin-right: 0.5em;
    font-size: 22px;
}

.create-social-post-widget .post-name-container .post-name-label {
    font-weight: 500;
}

.create-social-post-widget .trigger-select-container {
    border: 2px solid #e9e9ef;
    border-radius: 22px;
}

.create-social-post-widget .list-trigger-container .add-btn {
    width: 100%;
    height: 39px;
    background-color: #18aeff;
    border-radius: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-top: 15px;
}

.create-social-post-widget .list-input-container {
    border: 2px solid #e9e9ef;
    border-radius: 22px;
    padding: 22px 56px;
}

.create-social-post-widget .list-input-container .active-post-lists {
    text-align: center;
}

.create-social-post-widget .list-input-container .lists .list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #877d88;
    border-radius: 20px;
    font-size: 16px;
    color: #ffffff;
    padding: 11px 15px;
    margin-top: 11px;
}

.create-social-post-widget .list-input-container .lists .list .delete-list {
    cursor: pointer;
}

.create-social-post-widget .list-trigger-container .add-btn .plus-sign {
    height: 21px;
    width: 21px;
}

.create-social-post-widget .list-trigger-container .add-btn .plus-sign .default {
    fill: #ffffff;
}

.create-social-post-widget .cancel-btn {
    background: transparent;
    color: #877d88;
    border: none;
}

.create-social-post-widget .cancel-btn:hover {
    background: #e9e9ef;
}

.create-social-post-widget .field-container {
    margin-bottom: 23px;
}

.create-social-post-widget .trigger-select-container {
    margin-bottom: 30px;
}

.create-social-post-widget .trigger-label {
    position: relative;
    bottom: -12px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    background: #ffffff;
    margin: 0 auto;
    font-weight: 500;
    padding: 0 58px;
}

.create-social-post-widget .list-label,
.create-social-post-widget .date-label {
    position: relative;
    bottom: -12px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    background: #ffffff;
    margin: 0 auto;
    font-weight: 500;
    padding: 0 47px;
}

.create-social-post-widget .list-trigger-container {
    margin-bottom: 30px;
}

.create-social-post-widget .date-trigger-container .date-and-time-container {
    padding: 22px 56px;
    border: 2px solid #e9e9ef;
    border-radius: 22px;
}

.create-social-post-widget .date-trigger-container .date-and-time-container .hour,
.create-social-post-widget .date-trigger-container .date-and-time-container .minute,
.create-social-post-widget .date-trigger-container .date-and-time-container .time-multiselect,
.create-social-post-widget .date-trigger-container .date-and-time-container .time-zone-multiselect {
    width: 20px;
}

.create-social-post-widget .date-trigger-container .date-and-time-container .time-container {
    display: flex;
    justify-content: space-evenly;
}

.create-social-post-widget .timezone {
    width: 300px;
}

.create-social-post-widget .field-container .tag-list-input-results {
    display: flex;
    flex-wrap: wrap;
    margin-top: 7px;
}

.create-social-post-widget .field-container .tag-list-input-results .tag-list-input-result-item {
    margin-right: 0.5em;
    font-size: 11px;
    border: 1px #cac6cb solid;
    border-radius: 1.6em;
    padding: 0.5em 1em;
    max-width: 220px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: #000;
    display: flex;
    align-items: center;
}

.create-social-post-widget
    .field-container
    .tag-list-input-results
    .tag-list-input-result-item
    .delete-btn {
    position: -webkit-sticky;
    position: sticky;
    right: 0;
    font-size: 0.8em;
    margin-left: auto;
    color: red;
    font-weight: bold;
    margin-left: 10px;
    padding: 0.5em;
    width: 2.4em;
    height: 2.4em;
    text-align: center;
    border-radius: 10px;
}

.create-social-post-widget
    .field-container
    .tag-list-input-results
    .tag-list-input-result-item
    .delete-btn:hover {
    background-color: red;
    color: white;
}
</style>
